import { render, staticRenderFns } from "./ganttChart.vue?vue&type=template&id=b4cb0a70&scoped=true&"
import script from "./ganttChart.vue?vue&type=script&lang=js&"
export * from "./ganttChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cb0a70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4cb0a70')) {
      api.createRecord('b4cb0a70', component.options)
    } else {
      api.reload('b4cb0a70', component.options)
    }
    module.hot.accept("./ganttChart.vue?vue&type=template&id=b4cb0a70&scoped=true&", function () {
      api.rerender('b4cb0a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionProjectMgr/projectMgr/components/ganttChart.vue"
export default component.exports